// Flat-file style module specs for brand/product pages.
// Each page = theme (feature colour) + ordered list of modules.
// Module types: hero, about, rangeCards, fullImage, caseStudy, handles,
// featureSplit, benefits, brochureBanner, gallery, related.

const SF = "/sunflex-uk/files";
const BF = "/doors/bifold-doors/sunflex-uk-bifold-doors/files";
const SL = "/doors/sliding-doors/sunflex-uk-sliding-doors/files";
const GG = "/cms-data/gallery/sunflexgeneral";
const GB = "/cms-data/gallery/sunflexbifoldgal";
const GS = "/cms-data/gallery/sunflexslidinggal";

const SUNFLEX_THEME = { accent: "#F2C230", accentText: "#1e2a36", brand: "Sunflex UK", brochureLabel: "Download Sunflex Brochure" };
const RATIONEL_THEME = { accent: "#31465A", accentText: "#ffffff", brand: "Rationel", brochureLabel: "Download Rationel Brochure" };
const VELFAC_THEME = { accent: "#008071", accentText: "#ffffff", brand: "VELFAC", brochureLabel: "Download Velfac Brochure" };
const FORTIS_THEME = { accent: "#001B5E", accentText: "#ffffff", brand: "Fortis Aluminium", brochureLabel: "Download Fortis Brochure" };
const ENDURANCE_THEME = { accent: "#4A4B4D", accentText: "#ffffff", brand: "Endurance Doors", brochureLabel: "Download Endurance Brochure" };
const KOBBE_THEME = { accent: "#111111", accentText: "#ffffff", brand: "KOBBE", brochureLabel: "Download Kobbe Brochure" };
const CORTIZO_THEME = { accent: "#2678AA", accentText: "#ffffff", brand: "Cortizo", brochureLabel: "Download Cortizo Brochure" };
const LINIAR_THEME = { accent: "#31465A", accentText: "#ffffff", brand: "Liniar", brochureLabel: "Download Liniar Brochure" };
const RESIDENCE_THEME = { accent: "#2A363E", accentText: "#ffffff", brand: "The Residence Collection", brochureLabel: "Download Residence Brochure" };
const ALU_THEME = { accent: "#31465A", accentText: "#ffffff", brand: "Cedar Views", brochureLabel: "Download Brochure" };
const FO = "/entrance-doors/fortis-aluminium-doors/files";
const EN = "/entrance-doors/composite-front-doors/files";
const KO = "/entrance-doors/kobbe-doors/files";
const KG = "/cms-data/gallery/kobbegeneral";
const CS = "/doors/sliding-doors/cortizo-sliding-doors/files";
const CSG = "/cms-data/gallery/gallerysliding";
const CB = "/cortizo-bi-fold/files";
const CBG = "/cms-data/gallery/gallerybifoldcortizo";
const UP = "/windows/upvc-windows/files";
const RE = "/residence-collection/files";
const R9G = "/cms-data/gallery/galleryresidence9";
const R7F = "/residence-collection/residence-7/files";
const R9F = "/residence-collection/residence-9/files";
const RG = "/cms-data/gallery/galleryration";
const GC = "/cms-data/gallery/gallerycomp";
const FBLOG = "/cms-data/gallery/blog/admincore";
const ORIGIN_THEME = { accent: "#31465A", accentText: "#ffffff", brand: "Origin", brochureLabel: "Download Origin Brochure" };
const VE = "/velfac-windows-surrey/files";
const OR = "/origin/files";
const GV = "/cms-data/gallery/velfacgallery";
const GO = "/cms-data/gallery/origingeneral";
const RA = "/rationel-windows/files";
const GR = "/cms-data/gallery/rationelgallery";

const BS_THEME = { accent: "#31465A", accentText: "#ffffff", brand: "Cedar Views", brochureLabel: "Download Brochure" };
const BSG = "/cms-data/gallery/sunflexslidinggal";

export const BRAND_PAGES = {
  "/building-services/": {
    theme: BS_THEME,
    seoTitle: "Building Services | Extensions, Orangeries & Garden Rooms | Cedar Views",
    cta: "Building Services",
    modules: [
      {
        type: "hero",
        image: "/images/bs/hero.jpg",
        kicker: "Cedar Views · Beyond glazing",
        lines: ["Building", "Services"],
        subtitle: "Our trusted team work on projects across Surrey and Hampshire. Conservatory conversions, extensions, garden rooms and orangeries, delivered by one accountable team.",
        consultProduct: "Building Services",
      },
      {
        type: "about",
        number: "01",
        kicker: "Why choose Cedar Views",
        heading: "Over 200 years of combined building expertise.",
        paragraphs: [
          "Within the Cedar group, our team carries over 200 years of combined building and fenestration expertise. That means we do far more than supply and fit glazing, we design and deliver the building work around it: conservatory conversions, extensions, garden rooms and orangeries, completed to the same exacting standard as our windows and doors.",
          "From structural openings and lintels through to making good and the final finish, one accountable team is responsible for the whole result. Our trusted trades work on projects across Surrey and Hampshire, and because glazing is at the heart of what we do, the frames, doors and rooflights are never an afterthought.",
        ],
        quickEnquiry: true,
      },
      {
        type: "iconCards",
        number: "02",
        kicker: "Our building services",
        heading: "What we build.",
        text: "Four ways to transform your home, each designed around light and delivered end to end by the Cedar Views team.",
        items: [
          { icon: "/images/bs/small-2093.png", title: "Conservatory Conversions", to: "/building-services/conservatory-conversions/", d: "Transform a tired conservatory into a comfortable, year-round living space with a solid or hybrid roof conversion." },
          { icon: "/images/bs/small-2094.png", title: "Extensions", to: "/building-services/extensions/", d: "Single and double-storey extensions designed around light, with bifolds, sliders and rooflights built in from day one." },
          { icon: "/images/bs/small-2095.png", title: "Garden Rooms", to: "/building-services/garden-rooms/", d: "Elegant garden rooms that connect your home to the outdoors, glazed to maximise light and views." },
          { icon: "/images/bs/small-2126.png", title: "Orangeries", to: "/building-services/orangeries/", d: "The timeless pairing of brick and glass, crowned with a roof lantern, a true centrepiece for any home." },
        ],
      },
      {
        type: "benefits",
        number: "03",
        heading: "One team, start to finish",
        items: [
          { icon: "Ruler", title: "Design-led approach", text: "Every project starts with light: where it enters, how it moves and how the new space connects to the garden." },
          { icon: "ShieldCheck", title: "Structural integrity", text: "Openings, steels and roofs engineered and executed to maintain your home's strength." },
          { icon: "Award", title: "200+ years combined", text: "Building and fenestration experience within the Cedar group, FENSA registered." },
          { icon: "Cog", title: "In-house trades", text: "No juggling contractors, our trusted team handles the building work end to end." },
          { icon: "Check", title: "Seamless finish", text: "Making good, trims and details completed to installation standard." },
          { icon: "Lock", title: "One accountable team", text: "From the first cut to the final silicone bead, and we answer the phone afterwards, too." },
        ],
      },
      {
        type: "related",
        links: [
          { label: "Architects", to: "/architects/" },
          { label: "Developers", to: "/developers/" },
          { label: "Our Projects", to: "/projects/" },
        ],
      },
    ],
  },

  "/building-services/conservatory-conversions/": {
    theme: BS_THEME,
    seoTitle: "Conservatory Conversions Surrey & Hampshire | Cedar Views",
    cta: "Conservatory Conversions",
    modules: [
      {
        type: "hero",
        image: `${BSG}/svg20-camstrad-014.jpg`,
        breadcrumb: { label: "Building Services", to: "/building-services/" },
        kicker: "Design & build · Cedar Views",
        lines: ["Conservatory", "Conversions"],
        subtitle: "Turn a conservatory that's too hot in summer and too cold in winter into a room you'll use every day of the year.",
        consultProduct: "Conservatory Conversion",
      },
      {
        type: "about",
        number: "01",
        kicker: "Conservatory conversions",
        heading: "From occasional room to everyday living space.",
        paragraphs: [
          "Many conservatories across Surrey and Hampshire were built for a different era: single glazing, polycarbonate roofs and temperatures that swing with the seasons. A conservatory conversion replaces the failing roof and glazing with a properly insulated structure, transforming the space into a genuine extension of your home.",
          "We handle the whole conversion in-house: structural assessment, insulated solid or hybrid roof, plastering, high-performance glazing and doors, right through to the final decoration. Because Cedar Views is a glazing company first, the windows and doors that complete the room are specified to the same standard as everything else we install.",
        ],
        quickEnquiry: true,
      },
      {
        type: "benefits",
        number: "02",
        variant: "light",
        heading: "Why convert your conservatory?",
        items: [
          { icon: "ThermometerSun", title: "Comfortable all year", text: "An insulated roof keeps the heat out in summer and in through winter, so the room finally earns its keep." },
          { icon: "Sun", title: "Light without the glare", text: "Hybrid roofs with glazed panels or a roof lantern keep the space bright while taming solar gain." },
          { icon: "ShieldCheck", title: "Structurally assessed", text: "We survey the existing base and frames first, and only build on foundations that will last." },
          { icon: "Frame", title: "Glazing-led design", text: "New windows and doors specified from the same premium systems we install across our range." },
        ],
      },
      {
        type: "related",
        links: [
          { label: "Building Services", to: "/building-services/" },
          { label: "Extensions", to: "/building-services/extensions/" },
          { label: "Orangeries", to: "/building-services/orangeries/" },
          { label: "Roof Windows", to: "/roof-windows/" },
        ],
      },
    ],
  },

  "/building-services/extensions/": {
    theme: BS_THEME,
    seoTitle: "House Extensions Surrey & Hampshire | Cedar Views",
    cta: "Extensions",
    modules: [
      {
        type: "hero",
        image: "/origin/files/small-1348.jpg",
        breadcrumb: { label: "Building Services", to: "/building-services/" },
        kicker: "Design & build · Cedar Views",
        lines: ["Extensions"],
        subtitle: "Single and double-storey extensions designed around light, structure and glazing from the very first drawing.",
        consultProduct: "Extension",
      },
      {
        type: "about",
        number: "01",
        kicker: "House extensions",
        heading: "Designed around glazing, not squeezed around it.",
        paragraphs: [
          "The best extensions are conceived around light: where it enters, how it moves through the day, and how the new space connects to the garden. As glazing specialists with in-house building expertise, we design extensions from the opening out, so bifolds, sliders and rooflights are integral to the structure rather than an afterthought.",
          "Our team manages the project end to end: structural openings and steels, brickwork, roofing, insulation and finishing, with premium glazing from partners like Origin, Sunflex and Cortizo built in. One team, one programme, one point of accountability.",
        ],
        quickEnquiry: true,
      },
      {
        type: "benefits",
        number: "02",
        variant: "light",
        heading: "The Cedar Views difference",
        items: [
          { icon: "Ruler", title: "Design-led", text: "Every extension is planned around sightlines, daylight and the way you'll actually live in the space." },
          { icon: "Cog", title: "In-house trades", text: "Groundworks to final finish delivered by our own trusted team, no juggling contractors." },
          { icon: "ShieldCheck", title: "Engineered structure", text: "Steels, lintels and oversized openings engineered for the glazing they carry." },
          { icon: "Star", title: "Premium glazing built in", text: "Origin, Sunflex, Cortizo and VELFAC systems specified from day one, not retro-fitted." },
        ],
      },
      {
        type: "related",
        links: [
          { label: "Building Services", to: "/building-services/" },
          { label: "Garden Rooms", to: "/building-services/garden-rooms/" },
          { label: "Bifold Doors", to: "/doors/bifold-doors/" },
          { label: "Sliding Doors", to: "/doors/sliding-doors/" },
        ],
      },
    ],
  },

  "/building-services/garden-rooms/": {
    theme: BS_THEME,
    seoTitle: "Garden Rooms Surrey & Hampshire | Cedar Views",
    cta: "Garden Rooms",
    modules: [
      {
        type: "hero",
        image: `${BSG}/svg30-elsamhouse-0288.jpg`,
        breadcrumb: { label: "Building Services", to: "/building-services/" },
        kicker: "Design & build · Cedar Views",
        lines: ["Garden", "Rooms"],
        subtitle: "A calm, glazed retreat that blurs the line between inside and out.",
        consultProduct: "Garden Room",
      },
      {
        type: "about",
        number: "01",
        kicker: "Garden rooms",
        heading: "Rooms that live in the garden.",
        paragraphs: [
          "A well-designed garden room adds usable space and a genuine sense of escape: a studio, office, gym or simply somewhere to sit and watch the seasons change. We design and build garden rooms with glazing at their heart, slim-framed windows, sliding and bifold doors that open the room to the planting around it.",
          "Fully insulated and built to last, our garden rooms are constructed by the same trusted team that delivers our extensions and conversions across Surrey and Hampshire.",
        ],
        quickEnquiry: true,
      },
      {
        type: "benefits",
        number: "02",
        variant: "light",
        heading: "Built for every season",
        items: [
          { icon: "Sun", title: "Glazed to the garden", text: "Slim-framed sliding and bifold doors dissolve the boundary between room and planting." },
          { icon: "ThermometerSun", title: "Insulated throughout", text: "Floor, walls and roof insulated for comfortable use in January as well as July." },
          { icon: "Cog", title: "Built in-house", text: "Designed, constructed and glazed by one Cedar Views team, start to finish." },
          { icon: "Check", title: "Tailored to you", text: "Studio, office, gym or snug, sized and specified around how you'll use it." },
        ],
      },
      {
        type: "related",
        links: [
          { label: "Building Services", to: "/building-services/" },
          { label: "Orangeries", to: "/building-services/orangeries/" },
          { label: "Extensions", to: "/building-services/extensions/" },
          { label: "Sliding Doors", to: "/doors/sliding-doors/" },
        ],
      },
    ],
  },

  "/building-services/orangeries/": {
    theme: BS_THEME,
    seoTitle: "Orangeries Surrey & Hampshire | Cedar Views",
    cta: "Orangeries",
    modules: [
      {
        type: "hero",
        image: "/images/roof-lantern.jpg",
        breadcrumb: { label: "Building Services", to: "/building-services/" },
        kicker: "Design & build · Cedar Views",
        lines: ["Orangeries"],
        subtitle: "Brick, glass and a crown of light. The most elegant way to extend a period or contemporary home.",
        consultProduct: "Orangery",
      },
      {
        type: "about",
        number: "01",
        kicker: "Orangeries",
        heading: "The timeless elegance of the orangery.",
        paragraphs: [
          "An orangery pairs solid masonry with generous glazing and a striking roof lantern, offering the light of a conservatory with the comfort and presence of a true extension. It suits period properties and contemporary homes alike, adding a room with real architectural character.",
          "Cedar Views designs and builds orangeries complete: brickwork, insulated flat roof, aluminium roof lantern, windows and doors, all delivered by one team and finished to the standard our glazing clients expect.",
        ],
        quickEnquiry: true,
      },
      {
        type: "benefits",
        number: "02",
        variant: "light",
        heading: "Why choose an orangery?",
        items: [
          { icon: "Sun", title: "Crowned with light", text: "Slim aluminium roof lanterns flood the room with daylight without clunky bars or bulky ridges." },
          { icon: "Award", title: "Architectural character", text: "Masonry piers and a fascia line give the presence of a true extension, not a bolt-on." },
          { icon: "ThermometerSun", title: "Year-round comfort", text: "An insulated perimeter roof keeps the space usable and efficient in every season." },
          { icon: "ShieldCheck", title: "Built properly", text: "Foundations, brickwork and roof engineered and finished by our in-house team." },
        ],
      },
      {
        type: "related",
        links: [
          { label: "Building Services", to: "/building-services/" },
          { label: "Conservatory Conversions", to: "/building-services/conservatory-conversions/" },
          { label: "Roof Windows", to: "/roof-windows/" },
          { label: "Garden Rooms", to: "/building-services/garden-rooms/" },
        ],
      },
    ],
  },

  "/velfac-windows-surrey/": {
    theme: VELFAC_THEME,
    seoTitle: "VELFAC Windows and doors in Surrey and Hampshire",
    cta: "Velfac Windows",
    modules: [
      {
        type: "hero",
        image: `${GV}/sycamore-hall2_velfac-case_cta_1370x722.jpg`,
        kicker: "Brand Partner · Supplied & installed by Cedar Views",
        lines: ["Velfac", "Windows"],
        subtitle: "Velfac Windows & Doors in Surrey, Hampshire & Berkshire, supplied and installed by Cedar Views Chobham.",
        brochure: true,
        consultProduct: "Velfac Windows",
      },
      {
        type: "about",
        number: "01",
        kicker: "Danish composite windows, warm wood inside, aluminium outside",
        heading: "VELFAC windows and doors in Surrey and Hampshire.",
        paragraphs: [
          "Cedar Views Chobham is proud to supply VELFAC windows and doors to homeowners in Surrey and Hampshire. VELFAC windows boast a unique combination of warm wood on the inside and durable aluminium on the outside, offering unparalleled thermal efficiency and long-lasting durability. With their slim frames, these windows allow maximum natural light to flood your home, giving it a modern and sophisticated touch. Each VELFAC window is custom-made to perfectly fit your space and can be tailored to your personal preferences and requirements. Experience the superior quality and timeless elegance of VELFAC windows and doors at Cedar Views Chobham.",
        ],
        badges: [`${VE}/small-751.jpg`],
        sideImage: `${VE}/small-708.jpg`,
        quickEnquiry: true,
      },
      {
        type: "caseStudy",
        number: "02",
        kicker: "Case study",
        heading: "Be Inspired for your project",
        text: "We love this case study from VELFAC showcasing their range on a stunning renovation project.",
        video: "https://www.youtube.com/embed/P3jg5zAWNnI",
        logo: `${VE}/small-1022.jpg`,
        bg: "#008071",
        hideBrochure: true,
        link: { label: "Find out more", href: "https://velfac.co.uk/" },
      },
      {
        type: "benefits",
        number: "03",
        variant: "light",
        heading: "Key benefits with VELFAC windows",
        items: [
          { img: `${VE}/small-1122.png`, title: "Daylight optimisation", text: "Velfac's 54mm frame enhances the amount of glass in a window, allowing for 25% more natural light to enter your home as compared to regular options. This helps decrease the requirement for artificial lighting." },
          { img: `${VE}/small-1082.png`, title: "Energy efficient", text: "By opting for energy-efficient doors and windows, you can greatly decrease your energy expenses. VELFAC windows, in particular, are well-known for their exceptional track record in providing high energy performance." },
          { img: `${VE}/small-1095.png`, title: "Low environmental impact", text: "VELFAC windows and doors are renowned for their exceptional craftsmanship, as well as their utilization of sustainable materials to promote energy efficiency and reduce overall energy consumption and expenses." },
          { img: `${VE}/small-1108.png`, title: "Noise reduction", text: "VELFAC glazing is specifically engineered to diminish the intrusion of undesired noise, such as bustling traffic and other external disturbances." },
          { img: `${VE}/small-1126.png`, title: "Low maintenance", text: "Our high-quality composite alu/wood windows and doors are constructed using top-notch materials and are specifically designed to require minimal upkeep, all while maintaining excellent energy efficiency standards." },
          { img: `${VE}/small-1141.png`, title: "Burglar protection", text: "VELFAC windows and doors can resist damage inflicted by burglars using common tools, and withstand more serious attempt to buckle or deform entry or glazed doors." },
        ],
      },
      {
        type: "brochureBanner",
        image: `${GV}/tower-mill2-velfac-case_cta_1370x722.jpg`,
        text: "Click the link below to view a VELFAC brochure. If you have any questions regarding the range please contact our team and we will be happy to help.",
      },
      {
        type: "gallery",
        number: "04",
        images: [
          `${GV}/velfac-case_stour-house5_galleryoverview_890x890.jpg`, `${GV}/trelyn_velfac-case_galleryoverview_890x890.jpg`,
          `${GV}/tower-mill2-velfac-case_cta_1370x722.jpg`, `${GV}/sycamore-hall2_velfac-case_cta_1370x722.jpg`,
          `${GV}/sycamore-hall_velfac-case_cta_1370x722.jpg`, `${GV}/sycamore-hall_velfac-case_cta_1370x722-2.jpg`,
          `${GV}/r-affordable-home_velfac-case_galleryoverview_890x890.jpg`, `${GV}/pavilionhouse_velfac-case_galleryoverview_890x890.jpg`,
          `${GV}/garden-room4_velfac-case_cta_1370x722.jpg`, `${GV}/garden-room_velfac-case_galleryoverview_890x890.jpg`,
          `${GV}/gamekeeperslodge4_velfac-case_cta_1370x722.jpg`, `${GV}/four-oaks-velfac-case_galleryoverview_890x890.jpg`,
          `${GV}/fair-rising-velfac-case_galleryoverview_890x890.jpg`, `${GV}/barnstylevelfac6_cta_1370x720.jpg`,
          `${GV}/barnstylevelfac5_cta_1370x720.jpg`,
        ],
      },
      {
        type: "related",
        links: [
          { label: "Rationel Windows", to: "/rationel-windows/" },
          { label: "Residence Collection", to: "/residence-collection/" },
          { label: "Aluminium Windows", to: "/aluminium-windows/" },
          { label: "Origin Windows & Doors", to: "/origin/" },
        ],
      },
    ],
  },

  "/entrance-doors/fortis-aluminium-doors/": {
    theme: FORTIS_THEME,
    seoTitle: "Fortis Aluminium doors in Surrey and Hampshire",
    cta: "Fortis Door",
    modules: [
      {
        type: "hero",
        image: `${FO}/small-708.jpg`,
        breadcrumb: { label: "Entrance Doors", to: "/entrance-doors/" },
        kicker: "Brand Partner · Supplied & installed by Cedar Views",
        lines: ["Fortis", "Aluminium Doors"],
        subtitle: "Made in Britain. Supplied and installed by Cedar Views.",
        brochure: true,
        buttons: [
          { label: "Book an Appointment", href: "mailto:info@cedarviews.co.uk", style: "dark" },
          { label: "Quick Enquiry", href: "#enquiry", style: "green" },
        ],
        consultProduct: "Fortis Door",
      },
      {
        type: "about",
        number: "01",
        kicker: "Bespoke, handcrafted aluminium entrance doors",
        heading: "Fortis Aluminium doors in Surrey and Hampshire.",
        paragraphs: [
          "Fortis Aluminium, a leading door manufacturer based in the UK, specializes in creating bespoke, handcrafted aluminium doors. Each door is meticulously crafted from raw materials and thoughtfully selected components.",
          "As experts in our field, we offer the flexibility to bring your design visions to life, tailoring doors to meet your exact specifications and preferences.",
          "We understand the significance of choosing the perfect door, which is why we prioritize understanding your needs right from the outset. From your initial visit to one of our Fortis dealers at a showroom, through the surveying process, to the installation of your door, our dedicated team is committed to providing knowledgeable guidance every step of the way.",
        ],
        badges: [`${FO}/small-1022.png`, `${FO}/small-1210.jpg`],
        sideImage: `${FBLOG}/fortis-aluminium-front-door-camberley/modern-front-door-installation-surrey-sq.jpg`,
        quickEnquiry: true,
      },
      {
        type: "rangeCards",
        number: "02",
        heading: "Fortis Range",
        cards: [
          { img: `${FO}/small-1431.jpg`, title: "D72 Aluminium Doors", copy: "The Fortis D72 range offers fantastic levels of security, impressive thermal efficiency and benefits from the latest mechanical and electronic access technology." },
          { img: `${FO}/small-1430.png`, title: "Pivot Doors", copy: "Pivot doors are hinged from the top and bottom of the door rather than the side, like traditional entrance doors. Delivering a contemporary, unique look when open." },
        ],
      },
      {
        type: "splitCta",
        number: "03",
        kicker: "Design online, visualise at home",
        heading: "Try the Fortis Door Designer",
        text: "Design your D72 aluminium front door & visualise it on your home.",
        image: `${FO}/small-1427.png`,
        logo: `${FO}/small-1022.png`,
        button: { label: "Design Your Door", href: "https://cedarviews.doorconfigurator.com/" },
      },
      {
        type: "benefits",
        number: "04",
        heading: "Key benefits with Fortis Aluminium Doors",
        items: [
          { icon: "Award", title: "Made in Britain" },
          { icon: "ThermometerSun", title: "U values 0.71 W/m²K" },
          { icon: "ShieldCheck", title: "PAS:24 - D72" },
          { icon: "Lock", title: "Secured by Design locking & cylinder" },
          { icon: "Cog", title: "Marine grade stainless handles" },
          { icon: "Sun", title: "Excellent thermal insulation" },
          { icon: "BadgeCheck", title: "5 year guarantee" },
          { icon: "CloudRain", title: "Class 9A against driving rain" },
          { icon: "Frame", title: "Warp resistant profiles" },
          { icon: "Ruler", title: "Sizes up to 1.4m x 3m" },
          { icon: "Check", title: "Flush profiles" },
          { icon: "Eye", title: "Concealed hinges available" },
        ],
      },
      {
        type: "brochureBanner",
        image: `${FBLOG}/case-studies-clandon-origin-windows/origin-ow80-ob49-and-fortis-door-complete-project-clandon---edited-sq.jpg`,
        text: "Click the link below to view a Fortis brochure. If you have any questions regarding the range please contact our team and we will be happy to help.",
      },
      {
        type: "gallery",
        number: "05",
        images: [
          `${FBLOG}/fortis-aluminium-front-door-camberley/modern-front-door-installation-surrey-sq.jpg`,
          `${FO}/small-708.jpg`,
          `${FO}/small-1431.jpg`,
          `${FO}/small-1430.png`,
        ],
      },
      {
        type: "related",
        links: [
          { label: "Kobbe Doors", to: "/entrance-doors/kobbe-doors/" },
          { label: "Entrance Doors", to: "/entrance-doors/" },
          { label: "Composite Front Doors", to: "/entrance-doors/composite-front-doors/" },
          { label: "Cedar Essence", to: "/entrance-doors/cedar-essence/" },
        ],
      },
    ],
  },

  "/entrance-doors/composite-front-doors/": {
    theme: ENDURANCE_THEME,
    seoTitle: "Endurance Composite Front Doors in Surrey and Hampshire",
    cta: "Entrance / Front Doors",
    modules: [
      {
        type: "hero",
        image: `${EN}/small-684.jpg`,
        breadcrumb: { label: "Entrance Doors", to: "/entrance-doors/" },
        kicker: "Brand Partner · Supplied & installed by Cedar Views",
        lines: ["Composite", "Front Doors"],
        subtitle: "Made In Britain. The UK's strongest composite doors, supplied and installed by Cedar Views.",
        brochure: true,
        buttons: [
          { label: "Book an Appointment", href: "mailto:info@cedarviews.co.uk", style: "dark" },
          { label: "Quick Enquiry", href: "#enquiry", style: "green" },
        ],
        consultProduct: "Entrance / Front Doors",
      },
      {
        type: "about",
        number: "01",
        kicker: "Composite Front Doors from Cedar Views",
        heading: "Endurance Doors. The UK's strongest composite doors.",
        paragraphs: [
          "Discover our extensive selection of Endurance Doors, each designed to cater to individual preferences and requirements. Take the opportunity to explore our range and create your perfect door today.",
        ],
        badges: [`${EN}/small-709.png`],
        sideImage: `${GC}/skiddaw-1.jpg`,
        quickEnquiry: true,
      },
      {
        type: "rangeCards",
        number: "02",
        bg: "#4A4B4D",
        heading: "The Endurance Collections",
        cards: [
          { img: `${EN}/obgImage-776.jpg`, title: "The Classic Collection", copy: "Timeless doors inspired by the Georgian and Victorian periods. 20 different door styles, each available in 18 stunning colours with the option of matching coloured frames, combining the charm of yesteryears with modern security features." },
          { img: `${EN}/obgImage-812.jpg`, title: "The Urban Collection", copy: "10 contemporary and fashionable designs, an excellent choice for both modern residences and traditional properties, enhanced by our highly sought-after stainless steel pull handles and eye-catching glass designs." },
          { img: `${EN}/obgImage-847.jpg`, title: "The Country Collection", copy: "Classic shiplap styles that exude elegance, especially in earthy tones like Irish Oak and Golden Oak. For a bolder statement, consider Duck Egg Blue or Chartwell Green for a captivating, distinctive entrance." },
        ],
      },
      {
        type: "brochureBanner",
        image: `${GC}/country-10.jpg`,
        text: "Click the link below to request an Endurance brochure. If you have any questions regarding the range please contact our team and we will be happy to help.",
      },
      {
        type: "gallery",
        number: "03",
        images: [
          `${GC}/country-4-sq.jpg`, `${GC}/urban-10-sq.jpg`, `${GC}/country-1-sq.jpg`, `${GC}/country-5-sq.jpg`,
          `${GC}/monte-viso-sq.jpg`, `${GC}/bowmont-sq.jpg`, `${GC}/skiddaw-1-sq.jpg`, `${GC}/country-10-sq.jpg`,
          `${GC}/montblanc-sq.jpg`, `${GC}/etna-1-sq.jpg`, `${GC}/ben-nevis-sq.jpg`, `${GC}/country-3-sq.jpg`,
          `${GC}/country-7-sq.jpg`, `${GC}/cheviot-sq.jpg`, `${GC}/elbrus-sq.jpg`, `${GC}/country-8-sq.jpg`,
          `${GC}/country-9-sq.jpg`,
        ],
      },
      {
        type: "related",
        links: [
          { label: "Entrance Doors", to: "/entrance-doors/" },
          { label: "Fortis Aluminium Doors", to: "/entrance-doors/fortis-aluminium-doors/" },
          { label: "Kobbe Doors", to: "/entrance-doors/kobbe-doors/" },
          { label: "Cedar Essence", to: "/entrance-doors/cedar-essence/" },
        ],
      },
    ],
  },

  "/entrance-doors/kobbe-doors/": {
    theme: KOBBE_THEME,
    seoTitle: "Kobbe Aluminium doors in Surrey and Hampshire",
    cta: "Entrance / Front Doors",
    modules: [
      {
        type: "hero",
        image: `${KO}/obgImage-811.png`,
        breadcrumb: { label: "Entrance Doors", to: "/entrance-doors/" },
        kicker: "Brand Partner · Supplied & installed by Cedar Views",
        lines: ["Kobbe", "Aluminium Doors"],
        subtitle: "Supplied and installed by Cedar Views.",
        brochure: true,
        buttons: [
          { label: "Book an Appointment", href: "mailto:info@cedarviews.co.uk", style: "dark" },
          { label: "Quick Enquiry", href: "#enquiry", style: "green" },
        ],
        consultProduct: "Entrance / Front Doors",
      },
      {
        type: "about",
        number: "01",
        kicker: "Kobbe aluminium entrance doors",
        heading: "Every Door, Crafted with Precision.",
        paragraphs: [
          "At Cedar Views, we're proud to be trusted suppliers and professional installers of KOBBE aluminium entrance doors, renowned for their unbeatable quality, security, and design. Every KOBBE door is expertly manufactured in their own factory, giving full control over the entire process. This means you receive a door built with precision, durability, and attention to detail at every stage.",
          "With advanced aluminium engineering, KOBBE doors offer outstanding thermal performance and top-level security, without compromising on style. From contemporary to classic designs, there's a look to suit every home. Choose Cedar Views for expert advice, smooth installation, and a door that delivers long-lasting performance and kerb appeal.",
        ],
        badges: [`${KO}/small-1022.png`],
        sideImage: `${KO}/small-708.png`,
        quickEnquiry: true,
      },
      {
        type: "rangeCards",
        number: "02",
        heading: "The Kobbe Range",
        cards: [
          { img: `${KO}/small-1567.png`, title: "Alu Design" },
          { img: `${KO}/small-1566.jpg`, title: "XGlass" },
          { img: `${KO}/small-1556.png`, title: "Quartz" },
          { img: `${KO}/small-1544.png`, title: "Wood" },
          { img: `${KO}/small-1592.png`, title: "Pivot Collection" },
        ],
      },
      {
        type: "splitCta",
        number: "03",
        kicker: "Design online, visualise at home",
        heading: "Try the Kobbe Door Designer",
        text: "Design your perfect door.",
        image: `${KO}/small-1427.png`,
        logo: `${KO}/small-1022.png`,
        button: { label: "Design Your Door", href: "https://doordesigner.kobbe.co.uk/app/door/" },
      },
      {
        type: "benefits",
        number: "04",
        variant: "light",
        heading: "Key benefits with Kobbe Aluminium Doors",
        items: [
          { icon: "Cog", title: "Manufactured in KOBBE's own factory" },
          { icon: "Ruler", title: "Precision engineering at every stage" },
          { icon: "ThermometerSun", title: "Outstanding thermal performance" },
          { icon: "ShieldCheck", title: "Top-level security" },
          { icon: "Star", title: "Contemporary & classic designs" },
          { icon: "Award", title: "Long-lasting kerb appeal" },
        ],
      },
      { type: "fullImage", image: `${KO}/obgImage-820.jpg` },
      {
        type: "brochureBanner",
        image: `${KO}/obgImage-1190.jpg`,
        text: "Click the link below to view a KOBBE brochure. If you have any questions regarding the range please contact our team and we will be happy to help.",
      },
      {
        type: "gallery",
        number: "05",
        images: [
          `${KG}/kobbe_doors.jpg`, `${KG}/kb2210-oxide-nero-duzy.jpg`, `${KG}/kb2200-noir-desir-duzy.jpg`,
          `${KG}/kb2200_neolith_amazonico-duzy.jpg`, `${KG}/kb2050-pietra-di-savoia-grigia-duzy.jpg`,
          `${KG}/kb2050-pietra-di-savoia-grigia-duzy-1.jpg`, `${KG}/kb1000-z-drewnem-alu-wood-duzy.jpg`,
        ],
      },
      {
        type: "related",
        links: [
          { label: "Entrance Doors", to: "/entrance-doors/" },
          { label: "Fortis Aluminium Doors", to: "/entrance-doors/fortis-aluminium-doors/" },
          { label: "Composite Front Doors", to: "/entrance-doors/composite-front-doors/" },
          { label: "Cedar Essence", to: "/entrance-doors/cedar-essence/" },
        ],
      },
    ],
  },

  "/doors/sliding-doors/cortizo-sliding-doors/": {
    theme: CORTIZO_THEME,
    seoTitle: "Cortizo Sliding Doors in Surrey and Hampshire",
    cta: "Sliding Doors",
    modules: [
      {
        type: "hero",
        image: `${CS}/obgImage-652.jpg`,
        breadcrumb: { label: "Sliding Doors", to: "/doors/sliding-doors/" },
        kicker: "Brand Partner · Supplied & installed by Cedar Views",
        lines: ["Cortizo", "Doors"],
        subtitle: "Frameless sliding doors and windows, supplied and installed by Cedar Views.",
        brochure: true,
        consultProduct: "Sliding Doors",
      },
      {
        type: "about",
        number: "01",
        kicker: "The Infinity Collection · Frameless sliding",
        heading: "See as much of your view as possible.",
        paragraphs: [
          "When it comes to frameless sliding doors and windows our vision is simple, being able to see as much of your view as possible without the impediment of frames. A bespoke system, the Infinity Collection takes glazing to another level by making it invisible. Sliding doors have a flush fit system, and with an uniquely designed cill and drainage system you can say goodbye to the high thresholds of the past.",
          "These double and triple glazed products utilise the natural strength of aluminium. This allows for the design of slim, thermally broken profiles that maximise the amount of glazing. With a hard-wearing powder coating, 20mm sightlines, multi-point locking systems and U-values starting at 1.3W/M²k, frameless sliding doors effortlessly blend performance and style.",
        ],
        badges: [`${CS}/small-854.png`, `${CS}/small-858.png`],
        sideImage: `${CS}/small-735.jpg`,
        quickEnquiry: true,
      },
      {
        type: "caseStudy",
        number: "02",
        kicker: "Watch",
        heading: "Introducing Cortizo Cor Vision",
        video: "https://www.youtube.com/embed/u9xEVaWE1Ns",
        bg: "#2678AA",
        hideBrochure: true,
      },
      {
        type: "benefits",
        number: "03",
        variant: "light",
        heading: "Features",
        items: [
          { icon: "Eye", title: "Visible section of only 20mm" },
          { icon: "Frame", title: "Maximum surface glazing area" },
          { icon: "Ruler", title: "Frames can be embedded within the wall" },
          { icon: "Cog", title: "Possibility of pocket system" },
          { icon: "Check", title: "90° corner sashes without a mullion" },
        ],
      },
      { type: "fullImage", image: `${CS}/small-839.jpg` },
      {
        type: "brochureBanner",
        image: `${CS}/obgImage-726.jpg`,
        text: "Click the link below to request a Cortizo brochure. If you have any questions regarding the range please contact our team and we will be happy to help.",
      },
      {
        type: "gallery",
        number: "04",
        images: [`${CSG}/obgimage-652.jpg`, `${CSG}/obgimage-379.jpg`, `${CS}/obgImage-726.jpg`, `${CS}/small-735.jpg`],
      },
      {
        type: "related",
        links: [
          { label: "Sliding Doors", to: "/doors/sliding-doors/" },
          { label: "Cortizo Bifold Doors", to: "/cortizo-bi-fold/" },
          { label: "Sunflex Sliding Doors", to: "/doors/sliding-doors/sunflex-uk-sliding-doors/" },
          { label: "Bifold Doors", to: "/doors/bifold-doors/" },
        ],
      },
    ],
  },

  "/cortizo-bi-fold/": {
    theme: CORTIZO_THEME,
    seoTitle: "Cortizo Bifold doors in Surrey and Hampshire",
    cta: "Bi-Fold Doors",
    modules: [
      {
        type: "hero",
        image: `${CB}/obgImage-865.jpg`,
        breadcrumb: { label: "Bifold Doors", to: "/doors/bifold-doors/" },
        kicker: "Brand Partner · Supplied & installed by Cedar Views",
        lines: ["Cortizo", "Bifold Doors"],
        subtitle: "In partnership with Cortizo, one of Europe's leading aluminium systems suppliers.",
        brochure: true,
        consultProduct: "Bi-Fold Doors",
      },
      {
        type: "about",
        number: "01",
        kicker: "What are Cortizo aluminium bifold doors?",
        heading: "Bifold Cortizo Doors.",
        paragraphs: [
          "Cedar Views is proud to introduce our latest Bi-Fold Door System in partnership with CORTIZO. One of Europe's leading Aluminium Systems Suppliers. Cortizo bi-folding doors are a set of \u201cleaves\u201d or glass panels, which are engineered together in a series of doors that fold back on each other seamlessly along a durable aluminium frame.",
          "The installation of these cortizo doors allows a homeowner to create a seamless transition between their interior and exterior spaces creating the perfect environment for a large social occasion, or an excuse for an impromptu garden party or BBQ. Perhaps best of all, cortizo bifold doors allow you to maximise natural light even in the darker winter months, making the installation of aluminium bifolding doors an excellent addition to any British household.",
        ],
        badges: [`${CB}/small-854.png`, `${CB}/small-858.png`],
        sideImage: `${CB}/small-878.jpg`,
        quickEnquiry: true,
      },
      {
        type: "benefits",
        number: "02",
        variant: "light",
        heading: "Features",
        items: [
          { icon: "Eye", title: "Superb slimline aesthetics" },
          { icon: "ShieldCheck", title: "PAS24 accredited by the United Kingdom Accreditation Service" },
          { icon: "Ruler", title: "Market-leading sash of 1200mm" },
          { icon: "BadgeCheck", title: "Suitable for commercial, residential and new build applications" },
          { icon: "Star", title: "Available in RAL7016 Grey and Grey on White" },
        ],
      },
      { type: "fullImage", image: `${CBG}/cor06.jpg` },
      {
        type: "brochureBanner",
        image: `${CBG}/bifold9.jpg`,
        text: "Click the link below to request a Cortizo brochure. If you have any questions regarding the range please contact our team and we will be happy to help.",
      },
      {
        type: "gallery",
        number: "03",
        images: [
          `${CBG}/bifold1.jpg`, `${CBG}/bifold10.jpg`, `${CBG}/bifold9.jpg`, `${CBG}/bifold8.jpg`,
          `${CBG}/bifold7.jpg`, `${CBG}/bifold6.jpg`, `${CBG}/bifold5.jpg`, `${CBG}/cor06.jpg`,
          `${CBG}/cor05.jpg`, `${CBG}/cor07.jpg`,
        ],
      },
      {
        type: "related",
        links: [
          { label: "Bifold Doors", to: "/doors/bifold-doors/" },
          { label: "Cortizo Sliding Doors", to: "/doors/sliding-doors/cortizo-sliding-doors/" },
          { label: "Sunflex Bifold Doors", to: "/doors/bifold-doors/sunflex-uk-bifold-doors/" },
          { label: "Aluminium Windows", to: "/aluminium-windows/" },
        ],
      },
    ],
  },

  "/windows/upvc-windows/": {
    theme: LINIAR_THEME,
    seoTitle: "UPVC Windows",
    cta: "uPVC Windows",
    modules: [
      {
        type: "hero",
        image: `${UP}/obgImage-384.jpg`,
        breadcrumb: { label: "Windows", to: "/windows/" },
        kicker: "Liniar uPVC Systems · Supplied & installed by Cedar Views",
        lines: ["uPVC", "Windows"],
        subtitle: "UPVC is a simple choice when it comes to window replacement. A-rated as standard, with the option to upgrade to triple glazing.",
        brochure: true,
        consultProduct: "uPVC Windows",
      },
      {
        type: "about",
        number: "01",
        kicker: "Liniar uPVC windows",
        heading: "The simple choice for window replacement.",
        paragraphs: [
          "Cedar Views only offer A rated products as well as the option to upgrade to Triple Glazing. All systems offered by Cedar Views were designed with Strength, Durability and security in mind to help offer peace of mind. With a wide range of styles and colour options to choose from, there is an option to suit all properties within the Woking, Guildford and surrounding areas.",
        ],
        sideImage: `${UP}/obgImage-294.jpg`,
        quickEnquiry: true,
      },
      {
        type: "rangeCards",
        number: "02",
        heading: "Explore the Liniar Range",
        cards: [
          { img: `${UP}/obgImage-294.jpg`, title: "Casement Windows", to: "/upvc-windows/casement-windows/", copy: "Still the most popular choice for homes all over the UK, Liniar casement windows offer total versatility and either classic or contemporary style." },
          { img: `${UP}/obgImage-390.jpg`, title: "Flush Windows", to: "/upvc-windows/flush-finish/", copy: "A sash that closes perfectly level with the outer frame, recreating the elegance of traditional timber joinery with modern uPVC performance." },
          { img: `${UP}/obgImage-389.jpg`, title: "Resurgence", to: "/upvc-windows/resurgence/", copy: "Heritage character reborn. A mechanically-jointed flush window that faithfully replicates 19th-century timber originals." },
        ],
      },
      {
        type: "benefits",
        number: "03",
        variant: "light",
        heading: "Casement or flush?",
        items: [
          { icon: "Frame", title: "Casement Windows", text: "The opening sash sits slightly proud of the outer frame, the classic lipped profile seen across the UK. Slim sightlines, total versatility and excellent value." },
          { icon: "Eye", title: "Flush Windows", text: "The sash closes perfectly level with the frame for a clean, timber-look finish. Ideal for period properties and crisp contemporary designs alike." },
        ],
      },
      {
        type: "related",
        links: [
          { label: "Casement Windows", to: "/upvc-windows/casement-windows/" },
          { label: "Flush Finish", to: "/upvc-windows/flush-finish/" },
          { label: "Resurgence", to: "/upvc-windows/resurgence/" },
          { label: "Residence Collection", to: "/residence-collection/" },
        ],
      },
    ],
  },

  "/residence-collection/": {
    theme: RESIDENCE_THEME,
    seoTitle: "Residence Windows",
    cta: "Residence Collection",
    modules: [
      {
        type: "hero",
        image: `${RE}/obgImage-853.jpg`,
        breadcrumb: { label: "Windows", to: "/windows/" },
        kicker: "Brand Partner · Supplied & installed by Cedar Views",
        lines: ["Residence", "Collection"],
        subtitle: "Replicate traditional flush timber windows with modern efficiency.",
        brochure: true,
        consultProduct: "Residence Collection",
      },
      {
        type: "about",
        number: "01",
        kicker: "Designed and hand crafted in Great Britain",
        heading: "Residence Windows.",
        paragraphs: [
          "Cedar Views are proud suppliers of The Residence Collection in Woking and Guildford. This premium collection brings together window and door systems, designed and hand crafted in Great Britain. The residence collection boasts from a full luxury range of colours, the use of maintenance free materials, a 0.8 U-value and an A++ energy rating insuring that you really are benefiting from some of the best windows in the market.",
          "If you are looking for Residence windows or doors in the Woking, Guildford or Surrey area, please contact Cedar Views today.",
        ],
        sideImage: `${RG}/res9pic1.jpg`,
        quickEnquiry: true,
      },
      {
        type: "brandPanels",
        number: "02",
        heading: "Two signature ranges",
        panels: [
          { logo: `${RE}/small-568.png`, bg: "#2A363E", to: "/residence-collection/residence-7/", alt: "Residence 7" },
          { logo: `${RE}/small-570.png`, bg: "#000000", to: "/residence-collection/residence-9/", alt: "Residence 9" },
        ],
      },
      {
        type: "gallery",
        number: "03",
        images: [
          `${RG}/res9pic7.jpg`, `${RG}/res9pic6.jpg`, `${RG}/res9pic5.jpg`, `${RG}/res9pic4.jpg`,
          `${RG}/res9pic3.jpg`, `${RG}/res9pic2.jpg`, `${RG}/res9pic1.jpg`,
        ],
      },
      {
        type: "textBand",
        heading: "High resolution plans available on request",
        paragraphs: ["Contact our team and we will be happy to help."],
      },
      {
        type: "related",
        links: [
          { label: "Residence 7", to: "/residence-collection/residence-7/" },
          { label: "Residence 9", to: "/residence-collection/residence-9/" },
          { label: "uPVC Windows", to: "/upvc-windows/" },
          { label: "Flush Finish", to: "/upvc-windows/flush-finish/" },
        ],
      },
    ],
  },

  "/residence-collection/residence-7/": {
    theme: RESIDENCE_THEME,
    seoTitle: "Residence 7 Windows & Doors Surrey | Cedar Views",
    cta: "Residence 7",
    modules: [
      {
        type: "hero",
        image: `${R7F}/obgImage-721.jpg`,
        breadcrumb: { label: "Residence Collection", to: "/residence-collection/" },
        kicker: "Supplied & installed by Cedar Views",
        lines: ["Residence 7"],
        subtitle: "Flush inside and out. Seven chambers of quiet, warm, secure performance with a chic modern appearance.",
        brochure: true,
        consultProduct: "Residence 7",
      },
      {
        type: "about",
        number: "01",
        kicker: "Quintessentially British",
        heading: "Flawlessly flush, inside and out.",
        paragraphs: [
          "Cedar Views Windows are privileged to supply Residence 7 windows and doors in the Woking, Guildford and Surrey areas. Cedar and Residence are here to inspire you on your journey to create your dream home.",
          "Residence 7 windows from our Chobham showroom are a flush sash exterior and interior and thus gives the R7 its chic modern appearance and versatility to be used for both contemporary new builds and traditional British homes alike. All glass sightlines are perfectly equal providing symmetry for a timeless kerbside appeal.",
        ],
        badges: [`${R7F}/small-764.png`],
        sideImage: `${R7F}/small-844.jpg`,
        quickEnquiry: true,
      },
      {
        type: "benefits",
        number: "02",
        variant: "light",
        heading: "Residence 7 features",
        text: "Energy Saving Trust recommended.",
        items: [
          { icon: "Frame", title: "Seven chambers, 75mm deep", text: "Residence 7 has 7 chambers and is 75mm wide, resulting in superior thermal, acoustic, strength and security performance." },
          { icon: "ThermometerSun", title: "Energy efficient glazing", text: "Designed to accommodate energy efficient glazing, with options for 28mm double glazing or 44mm triple glazing." },
          { icon: "Lock", title: "Internally beaded", text: "The glazing bead is always on the inside, which also contributes to a higher security performance." },
          { icon: "Star", title: "Intelligent design", text: "R7 outperforms many other systems with a sophisticated 7 chamber design and intelligent features." },
        ],
      },
      { type: "fullImage", image: `${R7F}/obgImage-723.jpg` },
      {
        type: "featureSplit",
        heading: "Equal sightlines, timeless kerb appeal",
        paragraphs: [
          "Perfectly balanced glass sightlines give every elevation a calm, considered symmetry, equally at home on a contemporary new build or a traditional British property.",
          "See Residence 7 in the flesh at our Chobham showroom, and take a colour sample home.",
        ],
        image: `${R7F}/small-928.jpg`,
        reverse: true,
      },
      {
        type: "textBand",
        heading: "High resolution plans available on request",
        paragraphs: ["Contact our team and we will be happy to help."],
      },
      {
        type: "related",
        links: [
          { label: "Residence Collection", to: "/residence-collection/" },
          { label: "Residence 9", to: "/residence-collection/residence-9/" },
          { label: "uPVC Windows", to: "/upvc-windows/" },
        ],
      },
    ],
  },

  "/residence-collection/residence-9/": {
    theme: RESIDENCE_THEME,
    seoTitle: "Residence 9 Windows & Doors Surrey | Cedar Views",
    cta: "Residence 9",
    modules: [
      {
        type: "hero",
        image: `${R9G}/dsc1027-scaled.jpg`,
        breadcrumb: { label: "Residence Collection", to: "/residence-collection/" },
        kicker: "Supplied & installed by Cedar Views",
        lines: ["Residence 9"],
        subtitle: "The authentic timber designs of the 19th century, re-engineered with a thermally efficient nine chamber design and modern glazing.",
        brochure: true,
        consultProduct: "Residence 9",
      },
      {
        type: "about",
        number: "01",
        kicker: "Quintessentially British",
        heading: "The 19th century, re-engineered.",
        paragraphs: [
          "Introducing Residence 9, designed to replicate the authentic timber designs of the 19th century. Cedar Views Windows offers its window and door system to residents in Woking, Guildford and Surrey.",
          "By using traditional aesthetics with innovative design features, Residence 9 Windows ensure you will appreciate the benefits of a thermally efficient nine chamber design and modern glazing.",
        ],
        badges: [`${R9F}/small-778.png`, `${R9F}/small-782.png`],
        sideImage: `${R9F}/small-738.jpg`,
        quickEnquiry: true,
      },
      {
        type: "benefits",
        number: "02",
        variant: "light",
        heading: "Residence 9 features",
        items: [
          { icon: "Star", title: "Classic aesthetic", text: "The traditionally elegant flush exterior and stylish decorative interior create that classic aesthetic." },
          { icon: "ThermometerSun", title: "Nine chamber performance", text: "Accommodates highly efficient double or triple glazed units with market-leading thermal and acoustic performance." },
          { icon: "CloudRain", title: "Weather tested", text: "One of the highest classifications on the British Standard weather test, with optional steel reinforcement for grand entrance screens through to exceptional bays." },
          { icon: "Award", title: "Designed & made in the UK", text: "Created with the enduring designs of British architecture in mind, with bespoke options to satisfy everything up to the grandeur of stately homes." },
          { icon: "Ruler", title: "Article 4 sympathetic", text: "Key principles, shapes and dimensions extracted from the Article 4 Directions for windows, integrated with market-leading technology." },
          { icon: "Check", title: "Virtually maintenance free", text: "Your windows and doors won't warp, swell or flake, and never need sanding or painting." },
        ],
      },
      {
        type: "gallery",
        number: "03",
        images: [
          `${R9G}/dsc1027-scaled.jpg`, `${R9G}/residence-collection-windows-for-homeowners-in-weybridge-.jpg`,
          `${RG}/res9pic7.jpg`, `${RG}/res9pic5.jpg`, `${RG}/res9pic3.jpg`, `${RG}/res9pic2.jpg`,
        ],
      },
      {
        type: "textBand",
        heading: "High resolution plans available on request",
        paragraphs: ["Contact our team and we will be happy to help."],
      },
      {
        type: "related",
        links: [
          { label: "Residence Collection", to: "/residence-collection/" },
          { label: "Residence 7", to: "/residence-collection/residence-7/" },
          { label: "Flush Finish", to: "/upvc-windows/flush-finish/" },
        ],
      },
    ],
  },

  "/origin/": {
    theme: ORIGIN_THEME,
    seoTitle: "Origin Windows and Doors",
    cta: "Origin Windows & Doors",
    modules: [
      {
        type: "hero",
        image: `${GO}/_asp8253-copy-medium.jpg`,
        kicker: "Brand Partner · Manufactured in Britain",
        lines: ["Origin Windows", "and Doors"],
        subtitle: "Manufactured to the highest standards. Supplied and installed across Surrey and Hampshire by Cedar Views.",
        brochure: true,
        consultProduct: "Origin Windows & Doors",
      },
      {
        type: "about",
        number: "01",
        kicker: "Accredited Origin partner",
        heading: "Origin UK windows and doors in Surrey and Hampshire.",
        paragraphs: [
          "Origin stands as the premier manufacturer in the UK for tailor-made aluminium bi-folding, sliding, internal and front doors, along with high-quality windows. Serving as a comprehensive source for all aluminium doors and windows, they provide solutions and products catering to every client requirement and taste, be it in a residential or commercial context.",
          "Cedar Views is an accredited partner of Origin and we're proud to stock and install their products.",
        ],
        badges: [`${OR}/small-1210.png`, `${OR}/small-751.png`, `${OR}/small-1158.png`, `${OR}/small-1510.png`],
        sideImage: `${GO}/_asp3364_lowres.jpg`,
        quickEnquiry: true,
      },
      {
        type: "rangeCards",
        number: "02",
        heading: "The Origin Global Range",
        cards: [
          { img: `${OR}/small-1348.jpg`, title: "Bifold Doors", copy: "Origin's high quality bifold doors are offered in two truly stunning collections.", to: "/doors/bifold-doors/" },
          { img: `${OR}/small-1401.jpg`, title: "Internal Doors", copy: "A streamlined, contemporary aesthetic, a customised and timeless solution for dividing your space.", to: "/doors/internal-doors/" },
          { img: `${OR}/small-1566.jpg`, title: "Front Doors", copy: "Bespoke aluminium front doors, engineered for security and serious kerb appeal.", to: "/entrance-doors/" },
          { img: `${OR}/small-1554.jpg`, title: "Windows", copy: "Slim-framed aluminium windows, tailor-made at Origin's Buckinghamshire facility.", to: "/windows/aluminium-windows/" },
        ],
      },
      {
        type: "caseStudy",
        number: "03",
        kicker: "Amazing Origin case study",
        heading: "Origin, throughout the home.",
        text: "Check out this amazing Origin windows project. They have used windows and doors from Origin throughout.",
        video: "https://www.youtube.com/embed/g2qE3EjI3d0",
        logo: `${OR}/small-1526.png`,
      },
      {
        type: "benefits",
        number: "04",
        variant: "light",
        heading: "Key benefits with Origin Global",
        items: [
          { icon: "Award", title: "Manufactured in Britain", text: "Proudly manufactured in the United Kingdom at Origin's Buckinghamshire facility." },
          { icon: "BadgeCheck", title: "Industry-leading guarantees", text: "Discover industry leading guarantees for complete peace of mind." },
          { icon: "ThermometerSun", title: "Thermally efficient", text: "Doors and windows that help your house stay warm in winter and cool in the summer." },
          { icon: "ShieldCheck", title: "Safety & security", text: "Committed to your safety through compliance and accreditation initiatives." },
          { icon: "Star", title: "150+ colours & finishes", text: "A wide range of colour and finish options ensures there is a style to suit your home." },
          { icon: "Check", title: "Unbeatable lead times", text: "Origin's unbeatable delivery promises keep your project on programme." },
          { icon: "Cog", title: "Tailor-made", text: "All Origin products are tailor-made to your requirements by a highly skilled team." },
          { icon: "Frame", title: "Premium grade aluminium", text: "Strength, resilience and versatility from premium grade aluminium." },
          { icon: "Sun", title: "Low maintenance", text: "Expert engineering lets you enjoy the products rather than maintain them." },
        ],
      },
      {
        type: "gallery",
        number: "05",
        images: [
          `${GO}/_asp8039_lowres.jpg`, `${GO}/_asp3888_rt1-medium-2.jpg`, `${GO}/_asp1788.jpg`,
          `${GO}/_asp1285-comp2-rt-medium.jpg`, `${GO}/14.jpg`, `${GO}/10.jpg`,
          `${GO}/08.jpg`, `${GO}/03.jpg`, `${GO}/_asp1707.jpg`,
        ],
      },
      {
        type: "related",
        links: [
          { label: "Bifold Doors", to: "/doors/bifold-doors/" },
          { label: "Sliding Doors", to: "/doors/sliding-doors/" },
          { label: "Aluminium Windows", to: "/windows/aluminium-windows/" },
        ],
      },
    ],
  },

  "/windows/aluminium-windows/": {
    theme: ALU_THEME,
    seoTitle: "Aluminium Windows Surrey & Hampshire | Cedar Views",
    cta: "Aluminium Windows",
    modules: [
      {
        type: "hero",
        image: "/origin/files/small-1554.jpg",
        breadcrumb: { label: "Windows", to: "/windows/" },
        kicker: "Windows · Supplied & installed by Cedar Views",
        lines: ["Aluminium Windows,", "sleek, strong and", "built to last."],
        subtitle: "Premium aluminium window systems from Origin, Velfac, Rationel, Sunflex and Cortizo, designed, surveyed and installed by one accountable team.",
        buttons: [
          { label: "Book an Appointment", href: "mailto:info@cedarviews.co.uk", style: "dark" },
          { label: "Quick Enquiry", href: "#enquiry", style: "green" },
        ],
        consultProduct: "Aluminium Windows",
      },
      {
        type: "about",
        number: "01",
        kicker: "The definitive contemporary choice",
        heading: "Clean lines. Exceptional strength.",
        paragraphs: [
          "Aluminium is the definitive choice for contemporary architecture, a clean, minimalist aesthetic combined with exceptional strength. We supply and install premium aluminium window systems from Origin, Sunflex, Smarts, ALUK, Rationel and VELFAC, each selected for its engineering pedigree.",
          "From minimalist casements to floor-to-ceiling fixed panels, our team designs, surveys and installs across Surrey and Hampshire, including Farnham, Guildford, Winchester, Alton and the surrounding areas.",
        ],
        sideImage: "/cms-data/gallery/origingeneral/_asp3888_rt1-medium-2.jpg",
        quickEnquiry: true,
      },
      {
        type: "bento",
        number: "02",
        kicker: "Explore the range",
        heading: "Find your aluminium window",
        items: [
          { img: "/cms-data/gallery/origingeneral/_asp8253-copy-medium.jpg", title: "Aluminium Casement Windows", tag: "Style", d: "Slim frames, serious engineering. The versatile contemporary classic.", to: "/aluminium-windows/casement-windows/", span: "lg:col-span-7", h: "min-h-[420px]" },
          { img: "/cms-data/gallery/origingeneral/_asp3364_lowres.jpg", title: "Aluminium Flush Windows", tag: "Style", d: "Seamless, architectural, perfectly level sightlines.", to: "/aluminium-windows/flush-finish/", span: "lg:col-span-5", h: "min-h-[420px]" },
          { img: "/cms-data/gallery/origingeneral/14.jpg", title: "Origin Windows", tag: "Brand", d: "Britain's leading aluminium manufacturer.", to: "/origin/", span: "lg:col-span-4" },
          { img: "/cms-data/gallery/velfacgallery/sycamore-hall2_velfac-case_cta_1370x722.jpg", title: "Velfac Windows", tag: "Brand", d: "Danish composite, warm wood inside, aluminium outside.", to: "/velfac-windows-surrey/", span: "lg:col-span-4" },
          { img: "/cms-data/gallery/rationelgallery/rationel_bath_043.jpg", title: "Rationel Windows", tag: "Brand", d: "Scandinavian precision, certified performance.", to: "/rationel-windows/", span: "lg:col-span-4" },
          { img: "/cms-data/gallery/blog/admincore/crittall-style-windows-get-the-industrial-look-with-the-origin-soho-collection/soho-ob-36-oi-30-asp2858-sq.jpg", title: "Heritage Crittall Replacement", tag: "Heritage", d: "The industrial look, without the draughts.", to: "/heritage-crittal-replacement-windows/", span: "lg:col-span-12", h: "min-h-[340px]" },
        ],
      },
      {
        type: "benefits",
        number: "03",
        heading: "Why aluminium?",
        items: [
          { icon: "Frame", title: "Slim sightlines", text: "Ultra-slim frames maximise natural light and give you unobstructed views of your garden and beyond." },
          { icon: "Cog", title: "Low maintenance", text: "Powder-coated aluminium resists rust, fading and warping, virtually no upkeep, decade after decade." },
          { icon: "ThermometerSun", title: "Thermally efficient", text: "Modern thermal breaks with double or triple glazing deliver excellent, bill-reducing energy performance." },
          { icon: "BadgeCheck", title: "Long lifespan", text: "Exceptionally durable frames engineered to perform for decades, not years." },
          { icon: "Star", title: "Fully customisable", text: "A wide range of styles, colours, finishes and configurations tailored to your project." },
          { icon: "ShieldCheck", title: "Expertly installed", text: "Full supply-and-install service by our experienced, FENSA-registered team." },
        ],
      },
      {
        type: "gallery",
        number: "04",
        images: [
          "/cms-data/gallery/origingeneral/_asp8253-copy-medium.jpg",
          "/cms-data/gallery/origingeneral/_asp8039_lowres.jpg",
          "/cms-data/gallery/origingeneral/_asp3888_rt1-medium-2.jpg",
          "/cms-data/gallery/origingeneral/_asp3460lowres-small.jpg",
          "/cms-data/gallery/origingeneral/_asp3364_lowres.jpg",
          "/cms-data/gallery/origingeneral/_asp3215-comp-rtlowres-small.jpg",
        ],
      },
      {
        type: "related",
        links: [
          { label: "Origin Windows", to: "/origin/" },
          { label: "Velfac Windows", to: "/velfac-windows-surrey/" },
          { label: "Rationel Windows", to: "/rationel-windows/" },
          { label: "uPVC Windows", to: "/upvc-windows/" },
        ],
      },
    ],
  },

  "/doors/internal-doors/": {
    theme: ALU_THEME,
    seoTitle: "Internal Doors",
    cta: "Internal Doors",
    modules: [
      {
        type: "hero",
        image: "/doors/internal-doors/files/obgImage-275.jpg",
        breadcrumb: { label: "Doors", to: "/entrance-doors/" },
        kicker: "Doors · Supplied & installed by Cedar Views",
        lines: ["Internal", "Doors"],
        subtitle: "Internal glazed doors define space without sacrificing light.",
        consultProduct: "Internal Doors",
      },
      {
        type: "about",
        number: "01",
        kicker: "Divide space, not light",
        heading: "Connected, light-filled rooms.",
        paragraphs: [
          "Internal glazed doors define space without sacrificing light. Slim aluminium frames and expansive glass turn hallways, kitchens and living areas into connected, light-filled rooms.",
          "We supply and install Origin internal doors and the Smarts Aluspace internal screen system, available in single, double and fixed-screen configurations with a wide range of frame finishes.",
        ],
        sideImage: "/origin/files/small-1401.jpg",
        quickEnquiry: true,
      },
      {
        type: "bento",
        number: "02",
        kicker: "The ranges",
        heading: "Choose your system",
        items: [
          { img: "/doors/internal-doors/files/obgImage-275.jpg", title: "Origin Internal Doors", tag: "Brand", d: "Aluminium internal doors from Britain's leading manufacturer.", to: "/origin/", span: "lg:col-span-6", h: "min-h-[440px]" },
          { img: "/doors/internal-doors/files/obgImage-276.jpg", title: "Smarts Aluspace", tag: "Brand", d: "Slim, steel-look internal glazing screens and doors.", span: "lg:col-span-6", h: "min-h-[440px]", badge: "Ask in showroom" },
        ],
      },
      {
        type: "benefits",
        number: "03",
        variant: "light",
        heading: "Why internal glazing?",
        items: [
          { icon: "Sun", title: "Borrowed light between rooms" },
          { icon: "Frame", title: "Slim, steel-look sightlines" },
          { icon: "ShieldCheck", title: "Toughened safety glass" },
          { icon: "Ruler", title: "Made to measure" },
          { icon: "Star", title: "Single, double & fixed screens" },
          { icon: "Cog", title: "Wide range of finishes" },
        ],
      },
      {
        type: "related",
        links: [
          { label: "Origin Windows & Doors", to: "/origin/" },
          { label: "Entrance Doors", to: "/entrance-doors/" },
          { label: "Bifold Doors", to: "/doors/bifold-doors/" },
          { label: "Sliding Doors", to: "/doors/sliding-doors/" },
        ],
      },
    ],
  },

  "/roof-windows/": {
    theme: ALU_THEME,
    seoTitle: "Skylights and Roof lanterns in Chobham, Ascot and nearby areas",
    cta: "Roof Lantern / Rooflight",
    modules: [
      {
        type: "hero",
        image: "/roof-windows/flat-rooflight/files/obgImage-7200.jpg",
        breadcrumb: { label: "Windows", to: "/windows/" },
        kicker: "Windows · Supplied & installed by Cedar Views",
        lines: ["Let the", "light in."],
        subtitle: "Illuminating spaces with stunning glass solutions. Skylights and roof lanterns in Chobham, Ascot and nearby areas.",
        consultProduct: "Roof Lantern / Rooflight",
      },
      {
        type: "about",
        number: "01",
        kicker: "The elegance of simplicity",
        heading: "Sleeker, stronger, lighter.",
        paragraphs: [
          "For skylights and roof lanterns in Chobham, Ascot, and nearby areas, choose Cedar Views. We offer exquisite rooflight and lantern designs that enhance your home, providing breathtaking aerial views. Our craftsmanship and advanced thermal performance ensure year-round comfort in your conservatory, orangery, or extension.",
          "At Cedar Views, we believe in the elegance of simplicity for Surrey homes. Our roof lanterns are sleeker, stronger, and lighter, giving your property a sophisticated look. Say goodbye to clunky bars and bulky supports that clutter the ridge and hello to slim, elegant roof profiles that excel in thermal performance. Choose an all-aluminium structure or opt for PVCu capping, with Cedar Views, less creates a stunning and captivating roof aesthetic.",
        ],
        sideImage: "/cms-data/gallery/origingeneral/_asp8253-copy-medium.jpg",
        quickEnquiry: true,
      },
      {
        type: "bento",
        number: "02",
        kicker: "Roof glazing",
        heading: "Find your roof light",
        items: [
          { img: "/roof-windows/flat-rooflight/files/obgImage-7200.jpg", title: "Aluminium Flat Rooflights", tag: "Range", d: "A clean, minimal plane of glass for flat-roof extensions.", to: "/roof-windows/flat-rooflight/", span: "lg:col-span-7", h: "min-h-[420px]" },
          { img: "/images/roof-lantern.jpg", title: "Roof Lanterns", tag: "Range", d: "Slim, elegant lantern profiles that crown your extension.", span: "lg:col-span-5", h: "min-h-[420px]", badge: "Enquire for details" },
          { title: "Velux Roof Windows", tag: "Brand", d: "Pitched-roof windows from the world's best-known name in roof glazing.", bg: "#2A363E", span: "lg:col-span-12", h: "min-h-[240px]", badge: "Coming soon" },
        ],
      },
      {
        type: "benefits",
        number: "03",
        variant: "light",
        heading: "Why our roof glazing?",
        items: [
          { icon: "Sun", title: "Breathtaking natural light" },
          { icon: "Frame", title: "Slim, elegant profiles" },
          { icon: "ThermometerSun", title: "Advanced thermal performance" },
          { icon: "Cog", title: "Aluminium or PVCu capping" },
          { icon: "BadgeCheck", title: "Expertly installed" },
        ],
      },
      {
        type: "related",
        links: [
          { label: "Flat Rooflights", to: "/roof-windows/flat-rooflight/" },
          { label: "Aluminium Windows", to: "/aluminium-windows/" },
          { label: "Bifold Doors", to: "/doors/bifold-doors/" },
          { label: "Building Projects", to: "/building-services/" },
        ],
      },
    ],
  },

  "/rationel-windows/": {
    theme: RATIONEL_THEME,
    seoTitle: "Rationel Windows & Doors Surrey, Hampshire & Berkshire | Cedar Views",
    cta: "Windows & Doors",
    modules: [
      {
        type: "hero",
        image: `${GR}/rationel_bath_043.jpg`,
        kicker: "Brand Partner · Supplied & installed by Cedar Views",
        lines: ["Rationel", "Windows."],
        subtitle: "Rationel Windows & Doors in Surrey, Hampshire & Berkshire, covering Chobham, Ascot and surrounding areas.",
        brochure: true,
        consultProduct: "Windows & Doors",
      },
      {
        type: "about",
        number: "01",
        kicker: "Rationel Windows in Chobham, Ascot, and surrounding areas",
        heading: "Bespoke, sustainable windows and doors.",
        paragraphs: [
          "Rationel specialises in bespoke, sustainable windows and doors for commercial and residential properties. As a leader in innovation, design, and quality, we're renowned in Europe for low-energy buildings and Passive House construction. With over 60 years of experience, we're experts in energy-efficient double and triple glazed windows. Our global growth stems from our commitment to constant innovation and superior craftsmanship.",
          "Choose Rationel for iconic Scandinavian design, meticulous attention to detail, and industry-leading windows and doors. Our state-of-the-art factory and skilled technicians ensure compliance with European and UK standards. Experience Rationel: Superior windows and doors for every project.",
        ],
        badges: [`${RA}/small-751.png`],
        sideImage: `${RA}/small-708.jpg`,
        quickEnquiry: true,
      },
      {
        type: "caseStudy",
        number: "02",
        kicker: "Materials",
        heading: "Timber or aluminium clad timber windows?",
        text: "Rationel exclusively use timber, but for enhanced durability and reduced upkeep, we also provide aluminum-clad frames. Timber windows are an excellent option for both contemporary and classic residences. The incorporation of solid timber at the heart of our frames ensures exceptional thermal and acoustic efficiency. Alu clad windows retain the same solid timber core while introducing external aluminum cladding. This cladding significantly prolongs the lifespan of your windows and grants you windows that demand minimal upkeep, allowing you to effortlessly relish their benefits.",
        video: "https://www.youtube.com/embed/BAGyqn59VcI",
        logo: `${RA}/small-1022.png`,
      },
      {
        type: "rangeCards",
        number: "03",
        heading: "Understand the Rationel Range",
        cards: [
          { img: `${RA}/small-14-AE2.png`, title: "AURA", to: "/rationel-windows/aura/", copy: "Contemporary timber" },
          { img: `${RA}/small-27-AE2.png`, title: "AURA PLUS", to: "/rationel-windows/aura-plus/", copy: "Contemporary timber/aluminium" },
          { img: `${RA}/small-40-AE2.png`, title: "FORMA", to: "/rationel-windows/forma/", copy: "Traditional timber" },
          { img: `${RA}/small-53-AE2.png`, title: "FORMA PLUS", to: "/rationel-windows/forma-plus/", copy: "Traditional timber/aluminium" },
        ],
      },
      {
        type: "textBand",
        heading: "Why choose Rationel?",
        paragraphs: [
          "Rationel excels in Scandinavian architectural glazing design, optimizing natural light and ensuring exceptional weather resistance, security, and comfort. With headquarters in the UK, Ireland, and Denmark, Rationel has emerged as a reliable and esteemed company, recognized as a top manufacturer of high-quality aluminium clad and timber windows and doors. Each window and door undergoes meticulous craftsmanship using traditional methods and is constructed with premium sustainable materials. This meticulous approach guarantees the highest specifications and exceptional longevity for our products.",
        ],
      },
      {
        type: "brochureBanner",
        image: `${GR}/rationel_croyde_042.jpg`,
        text: "Click the link below to request a Rationel brochure. If you have any questions regarding the range please contact our team and we will be happy to help.",
      },
      {
        type: "gallery",
        number: "04",
        images: [
          `${GR}/rationel_falmouth_005.jpg`, `${GR}/rationel_croyde_042.jpg`, `${GR}/rationel_croyde_004.jpg`,
          `${GR}/rationel_croyde_002.jpg`, `${GR}/rationel_bideford_017.jpg`, `${GR}/rationel_bideford_014.jpg`,
          `${GR}/rationel_bath_043.jpg`, `${GR}/rationel_bath_010.jpg`, `${GR}/rationel_bath_004.jpg`,
          `${GR}/four-oaks-velfac-case4_cta_1370x722-1.jpg`, `${GR}/aura-triple-glaze.jpg`, `${GR}/2021_bellinge_06.jpg`,
          `${GR}/2021_albaek_02.jpg`, `${GR}/2017_randers_12.jpg`, `${GR}/2016_skjernvej_08.jpg`,
        ],
      },
      {
        type: "related",
        links: [
          { label: "Rationel AURA", to: "/rationel-windows/aura/" },
          { label: "Rationel FORMA", to: "/rationel-windows/forma/" },
          { label: "Velfac Windows", to: "/velfac-windows-surrey/" },
          { label: "Aluminium Windows", to: "/aluminium-windows/" },
        ],
      },
    ],
  },

  "/sunflex-uk/": {
    theme: SUNFLEX_THEME,
    seoTitle: "Sunflex UK Windows & Doors Surrey & Hampshire | Cedar Views",
    cta: "Patio doors",
    modules: [
      {
        type: "hero",
        image: `${GG}/sf75eco-oxshotthouse-014.jpg`,
        kicker: "Brand Partner · Supplied & installed by Cedar Views",
        lines: ["Sunflex", "UK."],
        subtitle: "Manufactured to the highest standards. Supplied and installed by Cedar Views.",
        brochure: true,
        consultProduct: "Sliding Doors",
      },
      {
        type: "about",
        number: "01",
        kicker: "The brand",
        heading: "Sunflex UK windows and doors in Surrey and Hampshire.",
        paragraphs: [
          "Cedar Views Chobham is now proud to offer the supply and installation of SUNFLEX UK products. SUNFLEX UK has established itself as a well-known producer of high-quality glazing systems, which encompass bifold doors and sliding doors that have received accolades for their excellence. With over two decades of expertise in crafting bifold and sliding doors, Sunflex products are celebrated for their exceptional performance, attractive design, and robust security features. Furthermore, they have gained a variety of esteemed certifications and awards, solidifying SUNFLEX UK's reputation as one of the most experienced manufacturers of bifold doors on a global scale.",
        ],
        badges: [`${SF}/small-751.png`, `${SF}/small-1158.png`, `${SF}/small-1210.jpg`, `${SF}/small-708.jpg`],
      },
      {
        type: "rangeCards",
        number: "02",
        heading: "Sunflex UK Range",
        cards: [
          { img: `${SF}/small-1348.jpg`, title: "BIFOLD DOORS", to: "/doors/bifold-doors/sunflex-uk-bifold-doors/", copy: "SUNFLEX UK's award-winning folding doors seamlessly integrate slender frame depths with unmatched performance and distinctive, pioneering attributes." },
          { img: `${SF}/small-1401.jpg`, title: "SLIDING DOORS", to: "/doors/sliding-doors/sunflex-uk-sliding-doors/", copy: "Modern aluminium sliding doors featuring exceptionally thin frames and expansive glass panels, ideal for optimising your outdoor views." },
        ],
      },
      {
        type: "caseStudy",
        number: "03",
        heading: "Incredible Sunflex UK case study",
        text: "The culmination of over a decade of meticulous planning and unwavering dedication to detail by the owners, this elegant 6-bedroom project represents the realization of their dream. Their vision was to transform a modest 1950s detached house into a spacious family home that exudes brightness, openness, and a warm welcome.",
        video: "https://www.youtube.com/embed/UwCxg35jneg",
        logo: `${SF}/small-751.png`,
      },
      {
        type: "benefits",
        number: "04",
        variant: "light",
        heading: "Key benefits with Sunflex UK doors",
        items: [
          { icon: "Check", title: "Doors which operate smooth and easily" },
          { icon: "Sun", title: "Industry-leading weatherproofing" },
          { icon: "BadgeCheck", title: "Over 20 years' experience of aluminium doors" },
          { icon: "ShieldCheck", title: "High security door systems" },
        ],
      },
      {
        type: "brochureBanner",
        image: `${GG}/sf55-exeter-617.jpg`,
        text: "Click the link below to request a SUNFLEX UK brochure. If you have any questions regarding the range please contact our team and we will be happy to help.",
      },
      {
        type: "gallery",
        number: "05",
        images: [
          `${GG}/sf75eco-poolhouse-015.jpg`, `${GG}/sf75eco-poolhouse-007.jpg`, `${GG}/sf75eco-oxshotthouse-014.jpg`,
          "/cms-data/gallery/blog/admincore/modern-aluminium-sliding-doors--statement-front-door-installation-in-fleet-hampshire/sunflex-fleet-sq.jpg",
          `${GG}/sf55-garden-008.jpg`, `${GG}/sf55-exeter-617.jpg`,
        ],
      },
      {
        type: "related",
        links: [
          { label: "Sunflex Bifold Doors", to: "/doors/bifold-doors/sunflex-uk-bifold-doors/" },
          { label: "Sunflex Sliding Doors", to: "/doors/sliding-doors/sunflex-uk-sliding-doors/" },
          { label: "Sliding Doors", to: "/sliding-doors/" },
        ],
      },
    ],
  },

  "/doors/bifold-doors/sunflex-uk-bifold-doors/": {
    theme: SUNFLEX_THEME,
    seoTitle: "Sunflex UK Bifold Doors Surrey & Hampshire | Cedar Views",
    cta: "Bi-Fold Doors",
    modules: [
      {
        type: "hero",
        image: `${GG}/sf55-exeter-617.jpg`,
        breadcrumb: { label: "Bifold Doors", to: "/doors/bifold-doors/" },
        kicker: "Sunflex UK",
        lines: ["Sunflex", "Bifold Doors."],
        subtitle: "Award winning Bifold doors supplied and installed by Cedar Views across Surrey and Hampshire.",
        brochure: true,
        buttons: [
          { label: "Book an Appointment", to: "/showroom/", style: "dark" },
          { label: "Quick Enquiry", href: "#enquiry", style: "green" },
        ],
        consultProduct: "Bi-Fold Doors",
      },
      {
        type: "about",
        number: "01",
        kicker: "The range",
        heading: "Sunflex UK Bifold doors in Surrey and Hampshire.",
        paragraphs: [
          "For over 35 years, SUNFLEX bifold doors have been installed in locations across the globe, offering the most extensive selection and setting the benchmark for folding doors, which includes both aluminum and timber-clad aluminum systems.",
          "Bifold patio doors effectively blur the boundaries between the indoors and outdoors. Their sleek, modern designs flood rooms with natural light when closed, and when opened, seamlessly unite your home with your garden.",
          "These bifold doors have the capacity to transform part of your home into an outdoor extension during the summer months, making them a stylish addition to any residence. When paired with flush or low-threshold tracks, SUNFLEX bifold doors can create a nearly seamless transition between the kitchen, living room, patio, or terrace, establishing the perfect entertaining space.",
          "With access to six distinct bifold systems, three track options, and a wide array of sizes and configurations, SUNFLEX bifold doors can be tailored to meet the precise specifications of your project.",
          "Cedar Views Chobham is now proud to offer the supply and installation of SUNFLEX UK products.",
        ],
        badges: [`${BF}/small-751.png`, `${BF}/small-1158.png`, `${BF}/small-1210.jpg`, `${BF}/small-1494.png`],
        sideImage: `${BF}/small-708.jpg`,
        quickEnquiry: true,
      },
      { type: "fullImage", image: `${GB}/sf75eco-steephouse-068.jpg` },
      {
        type: "caseStudy",
        number: "02",
        kicker: "Corner systems",
        heading: "Stunning Sunflex UK Corner Bifold Doors",
        text: "For over 35 years, SUNFLEX has been at the forefront of designing and producing aluminum bifold doors that transform a corner of your space, offering breathtaking panoramic views and establishing a seamless connection between your home and the garden.",
        video: "https://www.youtube.com/embed/iWp420VOjS8",
        logo: `${BF}/small-1022.png`,
      },
      {
        type: "featureSplit",
        heading: "Exclusive In-Line Handles for Bi-Fold Doors",
        image: `${BF}/small-1468.jpg`,
        paragraphs: [
          "Our bi-fold doors feature a distinctive design element with their in-line handles providing a seamless and unobstructed view through the glass. This meticulous attention to handle design is a hallmark of SUNFLEX bifold doors, resulting in a modern and elegant aesthetic when the doors are in the closed position.",
          "All handles are automatically color-matched to the door frame, and the lead door includes an in-line lever handle. The in-line flush handles operate the locking shootbolts on every second panel in the set. If you prefer a more traditional operation, you can also request a conventional horizontal handle with a latch for the lead door.",
        ],
      },
      {
        type: "featureSplit",
        heading: "Exclusive panel catch technology",
        image: `${BF}/small-1474.jpg`,
        reverse: true,
        paragraphs: [
          "Every SUNFLEX bifold door incorporates an exclusive panel catch technology, ensuring the lead door's secure placement when the doors are open, thus enhancing safety. With the doors fully open, this ingenious feature locks the lead door against the second panel, preventing unintentional closure, whether due to small children or gusts of wind.",
        ],
      },
      {
        type: "benefits",
        number: "03",
        heading: "Key benefits with Sunflex UK bifold doors",
        items: [
          { icon: "Frame", title: "Slender frames provide a stunning appearance" },
          { icon: "ThermometerSun", title: "Unrivalled thermal performance and weather protection" },
          { icon: "Award", title: "Manufactured with more than 35 years of folding door experience" },
          { icon: "ShieldCheck", title: "Secured by Design™ accredited security award" },
        ],
      },
      {
        type: "brochureBanner",
        image: `${GB}/sf75eco-oxshotthouse-008.jpg`,
        text: "Click the link below to request a FREE SUNFLEX UK brochure. If you have any questions regarding the range please contact our team and we will be happy to help.",
      },
      {
        type: "gallery",
        number: "04",
        images: [
          `${GB}/sf75eco-steephouse-068.jpg`, `${GB}/sf75eco-steephouse-033.jpg`, `${GB}/sf75eco-steephouse-023.jpg`,
          `${GB}/sf75eco-steephouse-014.jpg`, `${GB}/sf75eco-poolhouse-007-1.jpg`, `${GB}/sf75eco-oxshotthouse-021.jpg`,
          `${GB}/sf75eco-oxshotthouse-020.jpg`, `${GB}/sf75eco-oxshotthouse-010.jpg`, `${GB}/sf75eco-oxshotthouse-008.jpg`,
          `${GB}/sf75eco-bensonroad-010.jpg`, `${GB}/sf55-rusholme-005.jpg`, `${GB}/sf55-garden-014.jpg`,
          `${GB}/sf55-exeter-641.jpg`, `${GB}/sf55-brook-023.jpg`,
        ],
      },
      {
        type: "related",
        links: [
          { label: "Sunflex UK", to: "/sunflex-uk/" },
          { label: "Sunflex Sliding Doors", to: "/doors/sliding-doors/sunflex-uk-sliding-doors/" },
          { label: "All Bifold Doors", to: "/doors/bifold-doors/" },
        ],
      },
    ],
  },

  "/doors/sliding-doors/sunflex-uk-sliding-doors/": {
    theme: SUNFLEX_THEME,
    seoTitle: "Sunflex UK Sliding Doors Surrey & Hampshire | Cedar Views",
    cta: "Sliding Doors",
    modules: [
      {
        type: "hero",
        image: `${GS}/svg20-knatchbull-096.jpg`,
        breadcrumb: { label: "Sliding Doors", to: "/doors/sliding-doors/" },
        kicker: "Sunflex UK",
        lines: ["Sunflex", "Sliding Doors."],
        subtitle: "Award winning sliding doors supplied and installed by Cedar Views across Surrey and Hampshire.",
        brochure: true,
        buttons: [
          { label: "Book an Appointment", to: "/showroom/", style: "dark" },
          { label: "Quick Enquiry", href: "#enquiry", style: "green" },
        ],
        consultProduct: "Sliding Doors",
      },
      {
        type: "about",
        number: "01",
        kicker: "The range",
        heading: "Sunflex UK Sliding doors in Surrey and Hampshire.",
        paragraphs: [
          "For over 35 years, SUNFLEX doors have been installed in locations across the globe, offering the most extensive selection and setting the benchmark for premium glazing systems.",
          "Sliding patio doors effectively blur the boundaries between the indoors and outdoors. Their sleek, modern designs flood rooms with natural light when closed, and when opened, seamlessly unite your home with your garden.",
          "When paired with flush or low-threshold tracks, SUNFLEX sliding doors can create a nearly seamless transition between the kitchen, living room, patio, or terrace, establishing the perfect entertaining space.",
          "With a choice of the SVG20, SVG30 and SVG83 systems and a wide array of sizes and configurations, SUNFLEX sliding doors can be tailored to meet the precise specifications of your project.",
          "Cedar Views Chobham is now proud to offer the supply and installation of SUNFLEX UK products.",
        ],
        badges: [`${SL}/small-751.png`, `${SL}/small-1158.png`, `${SL}/small-1210.png`, `${SL}/small-1494.png`],
        sideImage: `${SL}/small-708.jpg`,
        quickEnquiry: true,
      },
      { type: "fullImage", image: `${GS}/svg20-camstrad-014.jpg` },
      {
        type: "caseStudy",
        number: "02",
        kicker: "Real project",
        heading: "Stunning River Thames Sunflex UK case study",
        text: "The red-brick bungalow situated on the site enjoyed unobstructed river views but did not fully capitalise on its exceptional location. In response, the owners embarked on a comprehensive redesign of the structure, resulting in the creation of a chic three-story residence equipped with five spacious sets of SVG30 sliding doors. These doors were installed to enhance the house's connection to its picturesque surroundings.",
        video: "https://player.vimeo.com/video/444504299",
        logo: `${SL}/small-1022.png`,
      },
      {
        type: "handles",
        heading: "Handle options",
        sub: "There are six sliding door handle options available:",
        items: [
          { img: `${SL}/small-1541.png`, label: "Stainless steel round feature handle" },
          { img: `${SL}/small-1542.png`, label: "Stainless steel rectangular feature handle" },
          { img: `${SL}/small-1543.png`, label: "Colour matched round feature handle" },
          { img: `${SL}/small-1544.png`, label: "Colour matched rectangular feature handle" },
          { img: `${SL}/small-1548.png`, label: "Colour matched D-handle" },
          { img: `${SL}/small-1557.png`, label: "Colour matched recessed handle" },
        ],
      },
      {
        type: "benefits",
        number: "03",
        heading: "Key benefits with Sunflex UK sliding doors",
        items: [
          { icon: "Eye", title: "A choice of sightlines", text: "You have the option to select from our new SVG20, featuring remarkably slim 20mm sight-lines, our exclusive SVG30 with slender 30mm frames, or the SVG83, which boasts slender 83mm interlocks, ensuring a genuinely high-performance sliding door system." },
          { icon: "Star", title: "Style and performance", text: "As with every SUNFLEX UK product, our sliding doors are meticulously designed to offer not only an attractive appearance but also effortless usability, ensuring consistent performance day after day, year after year." },
          { icon: "Cog", title: "Effortless operation", text: "Thanks to our meticulously engineered stainless steel running carriages, handling even the most substantial panel sizes has become a breeze. The era of cumbersome and hard-to-operate \"patio doors\" from the past is now a distant memory." },
          { icon: "CloudRain", title: "Severe weather rating", text: "Crafted with the aim of offering superior defense against wind and rain, our sliding doors undergo rigorous independent testing to ensure they meet severe weather rating performance standards. This feature renders them an excellent choice for even the most exposed and challenging locations." },
          { icon: "Lock", title: "Security as standard", text: "Equipped with a continuous 5-point lock mechanism on the lead door and featuring security hardware compliant with PAS 24:2016 and Secured by Design™ standards, our sliding doors offer advanced security as a standard feature." },
          { icon: "Ruler", title: "Slim from any angle", text: "Our sliding doors feature slender frame depths of only 59mm, eliminating the need for unsightly and cumbersome reinforcements to fortify the frame. This design ensures they maintain a sleek and slim appearance from any angle of view, not just when viewed head-on." },
        ],
      },
      {
        type: "brochureBanner",
        image: `${GS}/svg30-elsamhouse-0288.jpg`,
        text: "Click the link below to view a SUNFLEX UK brochure. If you have any questions regarding the range please contact our team and we will be happy to help.",
      },
      {
        type: "gallery",
        number: "04",
        images: [
          `${GS}/svg83-feldmann-031.jpg`, `${GS}/svg30-feldmann-010.jpg`,
          `${GS}/svg30-elsamhouse-0288.jpg`, `${GS}/svg30-elsamhouse-0239.jpg`, `${GS}/svg20-wickhamway-001.jpg`,
          `${GS}/svg20-liftslide-002.jpg`, `${GS}/svg20-knatchbull-096.jpg`, `${GS}/svg20-knatchbull-014.jpg`,
          `${GS}/svg20-camstrad-028.jpg`, `${GS}/svg20-camstrad-014.jpg`, `${GS}/svg20-algiers-008.jpg`,
        ],
      },
      {
        type: "related",
        links: [
          { label: "Sunflex UK", to: "/sunflex-uk/" },
          { label: "Sunflex Bifold Doors", to: "/doors/bifold-doors/sunflex-uk-bifold-doors/" },
          { label: "All Sliding Doors", to: "/doors/sliding-doors/" },
        ],
      },
    ],
  },
};

// old flat URLs kept live -> canonical brand page
export const BRAND_ALIASES = {
  "/sunflex-uk-bifold/": "/doors/bifold-doors/sunflex-uk-bifold-doors/",
  "/sunflex-uk-sliding-doors/": "/doors/sliding-doors/sunflex-uk-sliding-doors/",
  "/upvc-windows/": "/windows/upvc-windows/",
  "/aluminium-windows/": "/windows/aluminium-windows/",
  "/building/": "/building-services/",
  "/sliding-doors/": "/doors/sliding-doors/",
  "/bifold-doors/": "/doors/bifold-doors/",
  "/flush-finish/": "/upvc-windows/flush-finish/",
  "/windows/upvc-windows/casement-windows/": "/upvc-windows/casement-windows/",
  "/windows/upvc-windows/Flush-UPVC/flush-finish/": "/upvc-windows/flush-finish/",
  "/windows/upvc-windows/Flush-UPVC/resurgence/": "/upvc-windows/resurgence/",
};
